/**
 * Create a virtual DOM node
 * @param {string|Function} type - Element tag name or component function/class
 * @param {Object|null} props - Properties/attributes
 * @param {...any} children - Child vnodes, strings, or numbers
 * @returns {Object} VNode object
 */
export function h(type, props, ...children) {
    const flatChildren = children
        .flat(Infinity)
        .filter(child => child != null && child !== false && child !== true);

    return {
        type,
        props: props || {},
        children: flatChildren,
        key: props?.key ?? null
    };
}
